import React from 'react';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { useFormMethods } from '../../../../../../helpers/formManager';
import {
  SubmitProvider,
  useSubmitState,
  useSubmitSetState,
  SubmitContext,
} from './SubmitProvider';
import { ModalPropsProvider, ModalPropsContext } from './ModalPropsProvider';
import FormComponent from './FormComponent';
import { FormProvider } from './FormProvider';

const Provider = ({ children }) => {
  return (
    <SubmitProvider>
      <FormProvider>
        <ModalProvider>{children}</ModalProvider>
      </FormProvider>
    </SubmitProvider>
  );
};

function ModalProvider({ children }) {
  const setSubmitState = useSubmitSetState();

  const { reset } = useFormMethods();

  const { removeProps } = useModalMethods();

  const handleReset = () => {
    setSubmitState(null);
    reset({});
    removeProps(modalNames.attachmentsForm);
  };

  return (
    <ModalPropsProvider reset={handleReset}>{children}</ModalPropsProvider>
  );
}

function Form() {
  const submitState = useSubmitState();
  return <FormComponent submitStateMessage={submitState?.message} />;
}

const AddAttachmentStrategy = {
  Provider,
  SubmitContext,
  ModalPropsContext,
  fields: <Form />,
};

export default AddAttachmentStrategy;
